// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expand-enter-active[data-v-0a5cf14e],.expand-leave-active[data-v-0a5cf14e]{transition:all .3s ease-in-out;transform-origin:top}.expand-enter-from[data-v-0a5cf14e],.expand-leave-to[data-v-0a5cf14e]{opacity:0;transform:scaleY(0)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
